import React from "react";
import { Box, HStack, Text } from "@chakra-ui/react";
import { c } from "../classroomColors";
import { chartColors } from "../marking/markingTokens";

/**
 * The one line at the foot of a classroom card that decides whether it needs
 * opening today. The part-to-whole bar lives in the columns above, so this
 * stays a sentence rather than repeating the chart.
 */
const ClassroomStrip = ({ counts, total, toReview, isDark }) => {
  const cc = chartColors(isDark);
  if (!total) {
    return (
      <Text fontSize="11px" color={c.text} opacity={0.54}>
        No work set yet
      </Text>
    );
  }
  return (
    <HStack spacing="6px">
      {toReview > 0 && <Box boxSize="6px" borderRadius="full" bg={cc.to_review} flexShrink={0} />}
      <Text fontSize="11px" color={c.text} opacity={toReview > 0 ? 1 : 0.54}>
        {toReview > 0
          ? `${toReview} waiting on you`
          : `${total - counts.not_submitted} of ${total} handed in`}
      </Text>
    </HStack>
  );
};

export default ClassroomStrip;
